<template>
    <div class="main">
        <div class="mainBox">
            <h1 class="logo"></h1>
            <p class="slogan">{{ $t('errorPage.title') }}</p>
            <p class="lead">{{ $t('errorPage.lead') }}</p>
            <a @click="$router.go(-1)" class="btn_w backMain">{{ $t('back') }}</a>
            <p class="mail">{{ $t('errorPage.contactUs') }}:<a href="mailto:info@yscreatech.com">info@yscreatech.com</a></p>
            <div class="sloganfooter">©2014-2020 <br> Young Square Createch Ltd. All Rights Reserved. </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
